import React, { useEffect } from 'react';
import { ConversationQueryType, FilterRoute } from '@zonofi/zono-money-store';
import {
  EmptyStateView,
  EndListView,
  FilterModal,
  PullRefreshContainer,
  SpinnerLoader,
} from '../../components';
import { SemanticQueryCard, SemanticQueryCardSkeleton } from '../semantic-card';
import { QueryThreadCard } from '../thread-card/query-thread-card';
import { isEmpty } from 'lodash';
import { SVGS } from '../../assets';
import { useSemanticQueryDetails } from '../hooks';

interface SemanticQueryDetailsContentProps {
  filterPage?: string;
  showFilter?: boolean;
  setShowFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  setThreadCount?: React.Dispatch<React.SetStateAction<string>>;
}

export const SemanticQueryDetailsContent: React.FC<
  SemanticQueryDetailsContentProps
> = ({
  filterPage,
  showFilter = false,
  setShowFilter = () => {},
  setThreadCount = () => {},
}) => {
  const {
    queryData,
    queryConversationThreads,
    isLoading,
    isFetchingMore,
    onQueryThreadPress,
    onRefresh,
    lastItemRef,
    paginationData,
  } = useSemanticQueryDetails();

  useEffect(() => {
    if (paginationData?.total) {
      setThreadCount(String(paginationData?.total));
    }
  }, [paginationData?.total]);

  return (
    <>
      <div className="semantic-query-details__screen">
        <div>
          <div className="semantic-query-details__header-text font-semibold">
            {'QUERY ANALYSIS SUMMARY'}
          </div>
          {isLoading ? (
            <div className="semantic-query-details__skeleton-view">
              <SemanticQueryCardSkeleton item_count={1} />
            </div>
          ) : (
            <div className="semantic-query-details__query-card">
              <SemanticQueryCard
                query={queryData as ConversationQueryType}
                onPress={() => {}}
                showDivider={false}
                hideArrow
              />
            </div>
          )}
        </div>

        {isLoading ? (
          <div className="semantic-query-details__skeleton-view">
            <SemanticQueryCardSkeleton />
          </div>
        ) : (
          <>
            <div className="semantic-query-details__header-text  font-semibold">{`${paginationData?.total} THREADS`}</div>
            {isEmpty(queryConversationThreads) ? (
              <EmptyStateView
                imageSrc={SVGS.NoConversation}
                message={'No threads found'}
                description={'Try changing the date to view threads.'}
              />
            ) : (
              <PullRefreshContainer onRefresh={onRefresh}>
                <div className="semantic-query-details__query-card">
                  {queryConversationThreads?.map((thread, index) => (
                    <QueryThreadCard
                      key={index}
                      thread={thread}
                      onPress={onQueryThreadPress}
                      showDivider={index < queryConversationThreads?.length - 1}
                    />
                  ))}
                </div>
                <div ref={lastItemRef} style={{ height: 1 }} />
                {isFetchingMore && <SpinnerLoader />}
                {!isFetchingMore && (
                  <EndListView
                    className={'semantic-query-details__end-reach'}
                  />
                )}
              </PullRefreshContainer>
            )}
          </>
        )}
      </div>

      <FilterModal
        onClose={() => setShowFilter(false)}
        open={showFilter}
        route={FilterRoute.SemanticQuery}
        filterPage={filterPage}
      />
    </>
  );
};
